"use client";

import { Flex } from "@chakra-ui/react";
import { EmptyState } from "@/components/feedback";
import { Link, NavLink, Text } from "@/components/ui";
import { useTenantContentSettingsGet } from "@/features/profile-settings/hooks/useTenantContentSettingsGet";
import { useTenantData } from "@/hooks";
import { PageTypeGlobal, PageTypePortal } from "@/lib/types";
import { useThemeTokens } from "@/lib/theme/tokens";

interface TermsPageEmptyProps {
  /** Public marketing page vs member portal */
  variant?: "public" | "portal";
}

export const TermsPageEmpty = ({ variant = "public" }: TermsPageEmptyProps) => {
  const theme = useThemeTokens();
  const { tenantId } = useTenantData();
  const { data: contentSettings } = useTenantContentSettingsGet(
    { tenantId },
    { enabled: !!tenantId },
  );

  return (
    <EmptyState
      title={contentSettings.termsEmptyTitle}
      message={
        <Flex direction="column" gap={3} align="center" textAlign="center">
          <Text variant="secondary" fontSize="sm" lineHeight="1.6" maxW="md">
            {variant === "public"
              ? contentSettings.termsEmptyDescriptionPublic
              : contentSettings.termsEmptyDescriptionPortal}
          </Text>
          <Text variant="secondary" fontSize="sm" lineHeight="1.6" maxW="md">
            Questions?{" "}
            <Link
              as={NavLink}
              href={variant === "public" ? PageTypeGlobal.Contact : PageTypePortal.Contact}
              fontWeight="500"
              color={theme.accent.primary}
            >
              Contact us
            </Link>
            {variant === "public" ? (
              <>
                {" "}
                or{" "}
                <Link
                  as={NavLink}
                  href={PageTypePortal.SignUp}
                  fontWeight="500"
                  color={theme.accent.primary}
                >
                  create an account
                </Link>{" "}
                when you&apos;re ready to register.
              </>
            ) : null}
          </Text>
        </Flex>
      }
    />
  );
};
